import { createPostAsyncSlice } from '@sonar-software/xuder';
import { postSendInvitationLink } from '../../../../../../api';

export const adminUsersByIdLinksInvitationPostSlice = createPostAsyncSlice({
	name: 'AdminUsersByIdLinksInvitationSend',
	receive: true,
	request: true,
	requestHandler: postSendInvitationLink,
	retainDataOnRequest: false
});
